// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Coach Exercise Control — brand-aware layout */
.cec-page {
  min-height: 100vh;
  padding: 0 16px 32px;
  background-color: var(--brand-bg, #f4f5f6);
  background-image: linear-gradient(
    180deg,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.07) 0%,
    transparent 42%
  );
  font-family: var(--brand-font, "Poppins", sans-serif);
}

.cec-page--shell {
  min-height: 100vh;
  padding: 0;
  background-image: none;
}

.cec-scroll {
  background-image: linear-gradient(
    180deg,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06) 0%,
    transparent 36%
  );
}

@media (min-width: 600px) {
  .cec-page:not(.cec-page--shell) {
    padding: 0 24px 40px;
  }
}

/* Main + sequences side-by-side on wide screens (single scroll area) */
.cec-split {
  display: grid;
  gap: 12px;
  align-items: start;
}

@media (min-width: 960px) {
  .cec-split.has-sequences {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 380px);
  }
}

.cec-hero {
  border-radius: 16px;
  padding: 20px 20px 22px;
  margin-bottom: 20px;
  color: #fff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.cec-hero--compact {
  padding: 12px 16px 14px;
  margin-bottom: 0;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
}

.cec-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 100% 0%,
    rgba(255, 255, 255, 0.12) 0%,
    transparent 55%
  );
  pointer-events: none;
}

.cec-hero-inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.cec-hero-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px;
  flex-shrink: 0;
}

.cec-session-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 8px;
  font-size: 0.8125rem;
  opacity: 0.95;
}

.cec-timer-display {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
}

.cec-control-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

@media (min-width: 480px) {
  .cec-control-bar {
    flex-wrap: nowrap;
  }
}

/* Active sequence pulsing indicator */
.cec-seq-pulse {
  animation: cec-pulse 1.4s ease-in-out infinite;
}
@keyframes cec-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.45; transform: scale(0.75); }
}

/* Active sequence card left-border glow */
.cec-seq-active {
  animation: cec-seq-glow 2s ease-in-out infinite alternate;
}
@keyframes cec-seq-glow {
  0% { box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8,119,188), 0.12), 0 4px 16px rgba(var(--brand-primary-rgb, 8,119,188), 0.08); }
  100% { box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8,119,188), 0.22), 0 4px 20px rgba(var(--brand-primary-rgb, 8,119,188), 0.18); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/coach/CoachExerciseControl.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C;;;;GAIC;EACD,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,sCAAsC;AACtC;EACE,8CAA8C;AAChD;AACA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA,0CAA0C;AAC1C;EACE,yDAAyD;AAC3D;AACA;EACE,KAAK,iIAAiI,EAAE;EACxI,OAAO,iIAAiI,EAAE;AAC5I","sourcesContent":["/* Coach Exercise Control — brand-aware layout */\n.cec-page {\n  min-height: 100vh;\n  padding: 0 16px 32px;\n  background-color: var(--brand-bg, #f4f5f6);\n  background-image: linear-gradient(\n    180deg,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.07) 0%,\n    transparent 42%\n  );\n  font-family: var(--brand-font, \"Poppins\", sans-serif);\n}\n\n.cec-page--shell {\n  min-height: 100vh;\n  padding: 0;\n  background-image: none;\n}\n\n.cec-scroll {\n  background-image: linear-gradient(\n    180deg,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06) 0%,\n    transparent 36%\n  );\n}\n\n@media (min-width: 600px) {\n  .cec-page:not(.cec-page--shell) {\n    padding: 0 24px 40px;\n  }\n}\n\n/* Main + sequences side-by-side on wide screens (single scroll area) */\n.cec-split {\n  display: grid;\n  gap: 12px;\n  align-items: start;\n}\n\n@media (min-width: 960px) {\n  .cec-split.has-sequences {\n    grid-template-columns: minmax(0, 1fr) minmax(280px, 380px);\n  }\n}\n\n.cec-hero {\n  border-radius: 16px;\n  padding: 20px 20px 22px;\n  margin-bottom: 20px;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n}\n\n.cec-hero--compact {\n  padding: 12px 16px 14px;\n  margin-bottom: 0;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);\n}\n\n.cec-hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    circle at 100% 0%,\n    rgba(255, 255, 255, 0.12) 0%,\n    transparent 55%\n  );\n  pointer-events: none;\n}\n\n.cec-hero-inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.cec-hero-logo {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.15);\n  padding: 4px;\n  flex-shrink: 0;\n}\n\n.cec-session-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-top: 8px;\n  font-size: 0.8125rem;\n  opacity: 0.95;\n}\n\n.cec-timer-display {\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.04em;\n}\n\n.cec-control-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n\n@media (min-width: 480px) {\n  .cec-control-bar {\n    flex-wrap: nowrap;\n  }\n}\n\n/* Active sequence pulsing indicator */\n.cec-seq-pulse {\n  animation: cec-pulse 1.4s ease-in-out infinite;\n}\n@keyframes cec-pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.45; transform: scale(0.75); }\n}\n\n/* Active sequence card left-border glow */\n.cec-seq-active {\n  animation: cec-seq-glow 2s ease-in-out infinite alternate;\n}\n@keyframes cec-seq-glow {\n  0% { box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8,119,188), 0.12), 0 4px 16px rgba(var(--brand-primary-rgb, 8,119,188), 0.08); }\n  100% { box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8,119,188), 0.22), 0 4px 20px rgba(var(--brand-primary-rgb, 8,119,188), 0.18); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
